import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["value"]
  static values = {
    end:      Number,
    duration: { type: Number, default: 1600 },
    suffix:   String
  }

  connect() {
    if (!this.hasValueTarget) return
    this.observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.run()
          this.observer.unobserve(entry.target)
        }
      })
    }, { threshold: 0.4 })
    this.observer.observe(this.element)
  }

  disconnect() {
    if (this.observer) this.observer.disconnect()
  }

  run() {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      this.valueTarget.textContent = this.endValue
      return
    }
    const start = performance.now()
    const target = this.endValue
    const duration = this.durationValue
    const ease = t => 1 - Math.pow(1 - t, 3)

    const tick = (now) => {
      const elapsed = Math.min((now - start) / duration, 1)
      const current = Math.round(ease(elapsed) * target)
      this.valueTarget.textContent = current
      if (elapsed < 1) requestAnimationFrame(tick)
    }
    requestAnimationFrame(tick)
  }
}
